import React from 'react';
import {observer} from 'mobx-react';
import { extendObservable } from 'mobx';
import { Header, Input,Container, Button, Message, Form } from 'semantic-ui-react';
import styled from 'styled-components';

import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag'
const flex=styled.div`
    display:flex;
`;
const ini=styled.div`

`;
class Login extends React.Component{
    constructor(props) {
        super(props);
        extendObservable(this,{
            email: '',
            password: '',
            errors:{},
        });
    }
    onChange=(e) => {
        const {name,value}=e.target;
        this[name]=value;
    };
    onSubmit=async()=>{
        const {email,password}=this;
        const response=await this.props.mutate({
            variables:{email,password},
        });
        // console.log(response);
        const {ok,token,refreshToken,errors}=response.data.login;

        if(ok){
            localStorage.setItem('token',token);
            localStorage.setItem('refreshToken',refreshToken);
            this.props.history.push('/');
        }else{
            const err={};
            errors.forEach(({path,message})=>{
                err[`${path}Error`] = message;
            });
            this.errors=err;
        }
    };
    onRegister=()=>{
        this.props.history.push('/register');
    };
    render(){
        const {email, password,errors:{emailError,passwordError}} = this;
        const errorList=[];

        if(passwordError){
            errorList.push(passwordError);
        }
        if(emailError){
            errorList.push(emailError);
        }
        return (
            <Container text>
                <br/>
                <Form>
                    <Form.Field>
                        <Header as="h2">Login</Header>
                    </Form.Field>
                    <Form.Field error={!!emailError}>
                        <Input  name="email" onChange={this.onChange} value={email} placeholder="Email" fluid />
                    </Form.Field>
                    <Form.Field error={!!passwordError}>
                        <Input  name="password" type="password" onChange={this.onChange} value={password} placeholder="Password" fluid />
                    </Form.Field>
                    <Form.Field>
                        <flex>
                            <ini>
                                <Button onClick={this.onSubmit}>Login</Button>
                            </ini>
                            <ini>
                                <Button onClick={this.onRegister}>Register</Button>
                            </ini>
                        </flex> 
                    </Form.Field>
                </Form>
                { emailError || passwordError ?(
                        <Message
                            error
                            list={errorList}
                        />
                    ) : null}
            </Container>
        );
    }
    
};
const loginMutation=gql`
    mutation($email:String!,$password:String!){
        login(email:$email,password:$password){
            ok
            token
            refreshToken
            errors{
                path
                message
            }
        }
    }
`;

export default graphql(loginMutation)(observer(Login));